<div class="pl-page" *ngIf="post">

  <!-- The Apps & Plugins hero band (owner 2026-10-12): the category, the post's title (the page's H1) and when -->
  <header class="pl-hero post-hero">
    <div class="pl-hero-inner">
      <a [routerLink]="URLS.blog" [queryParams]="{ category: post.category }" class="pl-chip post-category">
        <span>{{ post.categoryLabel }}</span>
      </a>
      <h1 class="tools-title post-title">{{ post.title }}</h1>
      <p class="tools-subtitle post-meta">{{ post.dateLabel }} &middot; {{ post.readingTimeMinutes }} min read</p>
    </div>
  </header>

  <!-- every part of the post as a box in the cart's column (owner 2026-10-12): the article, its questions, where
       to go next and the posts beside it -->
  <article class="post-boxes">
  <div class="post-box post-read">
    <div class="post-cover-slot">
      <img class="post-cover" appImgFallback [src]="post.cover" [alt]="post.title" width="1200" height="600" decoding="async">
      <span class="img-fallback-caption">
        ⚠️ Under maintenance
        <span class="img-fallback-caption-sub">We are taking care of it. Please check back soon.</span>
      </span>
    </div>

    <div class="post-body" *ngIf="segments.length">
      <ng-container *ngFor="let seg of segments">
      <div *ngIf="seg.html" [innerHTML]="seg.html"></div>
      <ng-container *ngIf="seg.widget" [ngSwitch]="seg.widget">
        <app-screenshot-deck *ngSwitchCase="'screenshot-deck'" [shots]="seg.shots || []"></app-screenshot-deck>
        <app-color-converter *ngSwitchCase="'color-converter'" [hex]="post?.relatedColor || '549EFF'" [lockHex]="true"></app-color-converter>
        <app-harmony-preview *ngSwitchCase="'color-harmony'" [hex]="post?.relatedColor || '00BAFF'" [lockHex]="true" [wheels]="true"></app-harmony-preview>
        <app-readability-preview *ngSwitchCase="'readability'" [hex]="post?.relatedColor || '00BAFF'" [lockHex]="true"></app-readability-preview>
        <app-harmony-preview *ngSwitchCase="'opposites'" [only]="[ 'complementary', 'split' ]"
                             [hex]="post?.relatedColor || 'FF6A00'" [lockHex]="true"
                             [wheels]="true" heading="Try It Yourself"></app-harmony-preview>
        <app-light-mixer *ngSwitchCase="'light-mixer'" [hex]="post?.coverAccent || post?.relatedColor" heading="Try It Yourself"></app-light-mixer>
        <app-color-wheel *ngSwitchCase="'color-wheel'" [hex]="post?.relatedColor" heading="Try It Yourself"></app-color-wheel>
        <app-color-wheel *ngSwitchCase="'temperature'" [temperature]="true" [hex]="post?.relatedColor" heading="Try It Yourself"></app-color-wheel>
        <app-theme-palette *ngSwitchCase="'theme-palette'"
                           [theme]="( post?.relatedThemes && post.relatedThemes[0] ) || 'everest'" heading=""></app-theme-palette>
        <app-color-blindness *ngSwitchCase="'color-blindness'" heading="Try It Yourself"></app-color-blindness>
        <app-saturation-wheel *ngSwitchCase="'saturation-wheel'" [hex]="post?.relatedColor || '19AFA1'" heading="Try It Yourself"></app-saturation-wheel>
        <app-value-ladder *ngSwitchCase="'value-ladder'" [hex]="post?.relatedColor || '40E0D0'" heading="Try It Yourself"></app-value-ladder>
        <app-value-rise *ngSwitchCase="'value-rise'" [hex]="post?.relatedColor || 'F94144'" heading="Try It Yourself"></app-value-rise>
        <app-gradient-preview *ngSwitchCase="'gradient-preview'" heading="Try It Yourself"></app-gradient-preview>
        <app-mode-room *ngSwitchCase="'mode-room'" heading="Try It Yourself"></app-mode-room>
        <app-hwb-mixer *ngSwitchCase="'hwb-mixer'" [hex]="post?.relatedColor || 'DE8CB5'" heading="Try It Yourself"></app-hwb-mixer>
        <app-cmyk-mixer *ngSwitchCase="'cmyk-mixer'" [hex]="post?.relatedColor || 'FF5FA2'" heading="Try It Yourself"></app-cmyk-mixer>
      </ng-container>
      </ng-container>
    </div>

  </div>

    <!-- FAQ: native <details> accordion; the same Q&A is also emitted as FAQPage
         JSON-LD server-side (see scripts/seo-route-meta.js). -->
    <section class="post-box post-faq" *ngIf="post.faq?.length" aria-labelledby="post-faq-title">
      <h2 id="post-faq-title" class="faq-title">Frequently Asked Questions</h2>
      <div class="faq-list">
        <details class="faq-item" *ngFor="let item of post.faq">
          <summary class="faq-q">
            <span class="faq-q-text">{{ item.q }}</span>
            <span class="faq-q-icon" aria-hidden="true"></span>
          </summary>
          <p class="faq-a">{{ item.a }}</p>
        </details>
      </div>
    </section>

    <!-- Related: one consistent small wide box design for every target type. -->
    <div class="post-box related" *ngIf="relatedBoxes.length">
      <h2 class="related-title">{{ relatedTitle }}</h2>
      <div class="related-list">
        <ng-container *ngFor="let box of relatedBoxes">
          <!-- External (e.g. GitHub repo) -->
          <a *ngIf="box.external"
             class="related-box"
             [class.with-img]="box.bgImage"
             [class.is-theme]="box.themeIcon"
             [style.--box-accent]="box.accentColor || null"
             [style.background-image]="box.bgImage ? 'url(' + box.bgImage + ')' : null"
             (click)="onRelatedBoxClick( box )"
             [href]="box.href" target="_blank" rel="noopener">
            <span class="rb-scrim" *ngIf="box.bgImage"></span>
            <span class="rb-icon">
              <img *ngIf="box.iconImg" [src]="box.iconImg" [class.rb-github]="box.github" [class.rb-tool]="box.tool" [class.rb-themeicon]="box.themeIcon" alt="" loading="lazy">
              <span *ngIf="box.swatch" class="rb-swatch" [style.background]="box.swatch"></span>
            </span>
            <span class="rb-label">{{ box.label }}</span>
          </a>
          <!-- Internal (router) -->
          <a *ngIf="!box.external"
             class="related-box"
             [class.with-img]="box.bgImage"
             [class.is-theme]="box.themeIcon"
             [style.--box-accent]="box.accentColor || null"
             [style.background-image]="box.bgImage ? 'url(' + box.bgImage + ')' : null"
             (click)="onRelatedBoxClick( box )"
             [routerLink]="box.routerLink" [queryParams]="box.queryParams || {}">
            <span class="rb-scrim" *ngIf="box.bgImage"></span>
            <span class="rb-icon">
              <img *ngIf="box.iconImg" [src]="box.iconImg" [class.rb-github]="box.github" [class.rb-tool]="box.tool" [class.rb-themeicon]="box.themeIcon" alt="" loading="lazy">
              <span *ngIf="box.swatch" class="rb-swatch" [style.background]="box.swatch"></span>
            </span>
            <span class="rb-label">{{ box.label }}</span>
          </a>
        </ng-container>
      </div>
    </div>

    <!-- Premium Themes With A Similar Palette: at most two premium themes whose
         colors sit close to the post's free theme, chosen at build time
         (generate-blog.js premiumSuggestions). Many posts have none, and then
         nothing renders. Same box design as Keep Exploring, so it reads as a
         suggestion, not an ad. -->
    <section #premiumSection class="post-box related premium-related" *ngIf="premiumBoxes.length" aria-labelledby="premium-related-title">
      <h2 id="premium-related-title" class="related-title">Premium Themes With A Similar Palette</h2>
      <p class="related-lead" *ngIf="premiumAnchorName">Their colors sit close to {{ premiumAnchorName }}.</p>
      <div class="related-list">
        <a *ngFor="let box of premiumBoxes; let i = index"
           class="related-box is-theme"
           [style.--box-accent]="box.accentColor || null"
           (click)="onPremiumBoxClick( box, i )"
           [routerLink]="box.routerLink" [queryParams]="box.queryParams || {}">
          <span class="rb-icon">
            <img *ngIf="box.iconImg" [src]="box.iconImg" class="rb-themeicon" alt="" loading="lazy">
          </span>
          <span class="rb-label">{{ box.label }}</span>
        </a>
      </div>
    </section>

    <!-- Read More: its own section (parallel to FAQ / Keep Exploring), the
         prev/next cards inside it. -->
    <section class="post-box post-nav-section" *ngIf="post.prev || post.next">
      <h2 class="post-nav-heading">Read More</h2>
      <nav class="post-nav" aria-label="More posts">
        <a *ngIf="post.prev" [routerLink]="post.prev.url" (click)="onPostNavClick( 'newer' )" class="post-nav-item prev">
          <img *ngIf="post.prev.cover" class="post-nav-thumb" [src]="post.prev.cover"
               [alt]="post.prev.title" loading="lazy" decoding="async">
          <span class="post-nav-text">
            <span class="post-nav-label">&larr; Newer</span>
            <span class="post-nav-title">{{ post.prev.title }}</span>
          </span>
        </a>
        <span *ngIf="!post.prev" class="post-nav-spacer"></span>
        <a *ngIf="post.next" [routerLink]="post.next.url" (click)="onPostNavClick( 'older' )" class="post-nav-item next">
          <span class="post-nav-text">
            <span class="post-nav-label">Older &rarr;</span>
            <span class="post-nav-title">{{ post.next.title }}</span>
          </span>
          <img *ngIf="post.next.cover" class="post-nav-thumb" [src]="post.next.cover"
               [alt]="post.next.title" loading="lazy" decoding="async">
        </a>
      </nav>
    </section>
  </article>
</div>
